import { ToastContainer } from "@tuv-indo/toast";
import { useAtom } from "jotai";
import { useMemo, useState } from "react";
import { Link, NavLink } from "react-router-dom";

import { useExchangeToken } from "../../modules/advance-schedule/advance-schedule.service";
import {
    authAtom,
    authDisplayNameAtom,
    authRoleAtom,
} from "../../modules/auth/auth.atom";
import { CalendarIcon } from "../icons/CalendarIcon";
import { CogIcon } from "../icons/CogIcon";
import { UserIcon } from "../icons/UserIcon";
import {
    getNavigationByRole,
    NavigationItemType,
} from "./helper/navigation.helper";

const Icon = ({ type }: { type: IconType }) => {
    switch (type) {
        case "Questionnaire & Quotation":
            return <>Q </>;
        case "Surveillance List":
            return <>S </>;
        case "Recertification List":
            return <>R </>;
        case "Order":
            return <>O </>;
        case "Customers":
            return <>C </>;
        case "Invoice":
            return <>I </>;
        case "Daily Allowance":
            return <>D </>;
        case "Dashboard":
            return <>H </>;
        case "Advance Scheduling":
            return (
                <>
                    <CalendarIcon />
                </>
            );
        default:
            return <>x</>;
    }
};

const NavigationItem = (x: NavigationItemType) => {
    const [openSubNavigation, setOpenSubNavigation] = useState(false);
    return (
        <>
            <li className="text-xs">
                {!x.children && x.to && x.label !== "Advance Scheduling" && (
                    <NavLink
                        to={x.to}
                        className={({ isActive }) =>
                            ` ${
                                isActive
                                    ? "text-primary-content bg-primary"
                                    : "text-primary"
                            }  `
                        }
                    >
                        <Icon type={x.label as IconType} />
                        {x.label}
                    </NavLink>
                )}
                {x.label === "Advance Scheduling" && (
                    <div onClick={x.onClick} className={"text-primary"}>
                        <Icon type={x.label as IconType} />
                        {x.label}
                    </div>
                )}
                {x.children && (
                    <button
                        type="button"
                        onClick={() => setOpenSubNavigation(!openSubNavigation)}
                        className="text-primary"
                    >
                        <Icon type={x.label as IconType} />
                        {x.label}
                    </button>
                )}
            </li>
            {openSubNavigation && x.children && (
                <>
                    {x.children
                        .filter((xx) => xx.to)
                        .map((xx) => (
                            <li key={xx.label} className="text-xs">
                                <NavLink
                                    to={xx.to}
                                    className={({ isActive }) =>
                                        `pl-8 ${
                                            isActive
                                                ? "text-primary-content bg-primary"
                                                : "text-primary"
                                        } `
                                    }
                                >
                                    {xx.label}
                                </NavLink>
                            </li>
                        ))}
                </>
            )}
        </>
    );
};

export const Sidebar2 = () => {
    const [authDisplayName] = useAtom(authDisplayNameAtom);

    const [authRole] = useAtom(authRoleAtom);
    const [auth] = useAtom(authAtom);
    const navigation: NavigationItemType[] = useMemo(
        () => getNavigationByRole(authRole),
        [authRole]
    );
    const exchange = useExchangeToken({
        auth,
    });
    console.log(authRole, navigation);
    return (
        <>
            <div className="w-[254px] h-screen fixed ml-[52px] bg-base-100 shadow-xl overflow-auto">
                <div className="mx-4 border-b border-base-300 mt-8">
                    <div className="flex mb-2">
                        <div className="mr-4">
                            <div className="avatar">
                                <div className="w-[40px] rounded-full">
                                    <img
                                        src="https://via.placeholder.com/40"
                                        alt={authDisplayName}
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <p className="text-xs">
                                WELCOME TO <strong>SIMcert</strong>
                            </p>
                            <p className="text-lg">{authDisplayName}</p>
                            <p className="text-xs">{authRole?.join(" - ")}</p>
                        </div>
                    </div>
                    <div className="text-center block mb-2">
                        <Link to="/" className="btn btn-ghost btn-xs">
                            <CogIcon />
                        </Link>
                        <Link to="/" className="btn btn-ghost btn-xs">
                            <UserIcon />
                        </Link>
                    </div>
                </div>
                <ul className="menu bg-base-100 p-2 rounded-box">
                    {navigation.map((x) => {
                        return (
                            <NavigationItem
                                key={x.label}
                                {...x}
                                onClick={
                                    x.label === "Advance Scheduling"
                                        ? exchange
                                        : undefined
                                }
                            />
                        );
                    })}
                </ul>
            </div>
            <ToastContainer direction="top-right" />,
        </>
    );
};

type IconType =
    | "Questionnaire & Quotation"
    | "Surveillance List"
    | "Recertification List"
    | "Order"
    | "Customers"
    | "Invoice"
    | "Dashboard"
    | "Daily Allowance"
    | "Advance Scheduling";
